export default __webpack_public_path__ + "assets/audios/dfcf61b9ce178b20e6efb581e2f71264.mp3";